import { compact, map } from 'lodash-es';

export abstract class MapperBase<TSource, TDestination> {
	public mapWith(
		source: TSource,
		specializedMapper: SpecializedMapperFunc<TSource, TDestination>,
		options?: MapperOptions
	): TDestination {
		const result = this.map(source, options);
		return specializedMapper(source, result) || result;
	}

	public mapCollection(
		sourceCollection: Array<TSource>,
		options?: CollectionMapperOptions
	): Array<TDestination> {
		let result = map(sourceCollection, (sourceItem) =>
			this.map(sourceItem, options)
		);

		if (options?.compact) {
			result = compact(result);
		}

		return result;
	}

	public mapCollectionWith(
		sourceCollection: Array<TSource>,
		specializedMapper: SpecializedMapperFunc<TSource, TDestination>,
		options?: CollectionMapperOptions
	): Array<TDestination> {
		let destResult = map(sourceCollection, (sourceItem) =>
			this.mapWith(sourceItem, specializedMapper, options)
		);
		if (options?.compact) {
			destResult = compact(destResult);
		}
		return destResult;
	}

	public abstract map(
		source: TSource,
		options?: MapperOptions
	): TDestination;
}

export interface MapperOptions {
	[key: string]: any;
}

export interface CollectionMapperOptions extends MapperOptions {
	compact?: boolean;
}

export type SpecializedMapperFunc<TSource, TDestination> = (
	source: TSource,
	destination: TDestination
) => void | TDestination;
